import { MutableRefObject } from "react";
import usePaginationFilter from "../../../../hooks/usePaginationFilter";
import { ListaInformacoesVendasController } from "../../../../Controllers/Cobranca/GestaoAtendimento/HistoricosControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { ColumnDescription } from "react-bootstrap-table-next";
import { ILstInforVendasResponse } from "../../../../Interfaces/Geral/Historicos/HistoricoInterface";
import Table from "../../../../Components/Table";
import FiltroEmpreendimentoResumo from "./FiltroEmpreendimentoResumo/FiltroEmpreendimentoResumo";
import { formatMoneyReais } from "../../../../Tools/FormatTools";

interface IEmpreendimentoResumo {
    dtPeriodoInicial: MutableRefObject<string>;
    dtPeriodoFinal: MutableRefObject<string>;
    ID_EMPREENDIMENTO: number;
}

export default function EmpreendimentoResumo(props: IEmpreendimentoResumo) {
    const { filter, setFilter } = usePaginationFilter<{
        DT_INICIO: string;
        DT_FIM: string;
        ID_EMPREENDIMENTO: number;
    }>({
        page: 1,
        filter: {
            DT_INICIO: props.dtPeriodoInicial.current,
            DT_FIM: props.dtPeriodoFinal.current,
            ID_EMPREENDIMENTO: props.ID_EMPREENDIMENTO,
        },
    });

    const {
        value: lstInformacoesVendas,
        loading: lstInformacoesVendasLoading,
        // execute: updateList,
    } = useAsyncEffect(async () => {
        if (filter?.DT_FIM || filter?.DT_INICIO || filter?.ID_EMPREENDIMENTO)
            return ListaInformacoesVendasController(
                filter?.ID_EMPREENDIMENTO ?? "",
                // "2021-01-01",
                // "2024-12-31"
                filter?.DT_FIM ? filter?.DT_FIM : "",
                filter?.DT_INICIO ? filter?.DT_INICIO : ""
            );
    }, [filter]);

    const gestaoVisitaColumns: Array<
        ColumnDescription<ILstInforVendasResponse>
    > = [
        { dataField: "DS_NOME_CLIENTE", text: "Cliente" },
        {
            dataField: "VLR_TOTAL_PRODUTO",
            text: "Valor Total",
            formatter: (c, row) => {
                return <span>{formatMoneyReais(c)}</span>;
            },
        },
        {
            dataField: "DT_VENDA",
            text: "Data da Venda",
            formatter: (cell) => new Date(cell).toLocaleDateString("pt-BR"),
        },
        {
            dataField: "DS_PRODUTO_COMP",
            text: "Produto",
        },
    ];

    function handleFilter(formData: {
        DT_INICIO: string;
        DT_FIM: string;
        ID_EMPREENDIMENTO: number;
    }) {
        setFilter(formData);
    }

    return (
        <div className="card card-custom p-10">
            <div className="w-100 d-flex justify-content-between align-items-center mb-8">
                <h4>Informações de Vendas</h4>
            </div>

            <Table
                defaultStyle={{
                    align: "center",
                    classes: "p-8",
                }}
                bordered={false}
                striped
                columns={gestaoVisitaColumns}
                data={lstInformacoesVendas ?? []}
                keyField="ID_PRODUTO"
                classes="v-middle-cells"
                wrapperClasses="mw-100 custom-scroll"
                noDataIndication={
                    <div className="text-muted text-center">
                        Não há dados para exibir
                    </div>
                }
                loading={lstInformacoesVendasLoading}
                noSearch
            />

            <FiltroEmpreendimentoResumo
                handleFilter={handleFilter}
                filter={filter}
            />
        </div>
    );
}
